<template>
  <div id="app" :class="{'show-menu': showMenu}">
    <el-container>
      <el-header >
        <div class="wrapper">
          <div class="logo" @click="goToLink"> <img src="@/assets/logo.png"/></div>
          <div class="menu" :class="{'show': showMenu}">
            <el-menu :default-active="activeIndex" :router="true" class="el-menu-demo" mode="horizontal" @select="showMenu = false">
              <el-menu-item v-for="item in routers" :key="item.path" :index="`${item.path}`">{{item.meta?.title}}</el-menu-item>
            </el-menu>
          </div>
          <!--yi移动端-->
          <div class="right-btn" :class="{'close': showMenu}" @click="showMenu = !showMenu">
            <span></span>
            <span></span>
            <span></span>
          </div>
        </div>
      </el-header>
      <el-main>
        <keep-alive>
          <router-view/>
        </keep-alive>

      </el-main>
    </el-container>


  </div>
</template>
<script>
export default {
  data(){
    return {
      routers:[],
      showMenu: false
    }
  },
  computed:{
    activeIndex(){
      let path = this.$route.path
      if(path === '/ExplorationVehicle'||path === '/product'){
        path = '/scheme'
      }
      return path
    }
  },

  created() {
    this.routers = this.$router.options.routes.filter(item => !!item.meta)
  },
  methods:{
    goToLink(){
      window.location.href = "http://www.datacreateai.com/"
    }
  }
}
</script>
<style lang="scss">
@font-face {
  font-family: 'HarmonyOS-Regular';
  src: url(./assets/font/HarmonyOS_Sans_TC_Regular.ttf);
}
@font-face {
  font-family: 'MiSans-Regular';
  src: url(./assets/font/MiSans-Regular.ttf);
}
*{
  font-family: MiSans-Regular,HarmonyOS-Regular, Helvetica Neue, Helvetica, PingFang SC, Hiragino Sans GB, Microsoft YaHei, SimSun, sans-serif;
}
html,body{
  margin: 0;
  padding: 0
}
#app {
  .el-main{
    min-height: 100vh;
    padding: 0;
  }
}
.el-header{
  backdrop-filter: blur(10px);
  position: absolute;
  width: 100%;
  z-index: 100;
  height: 100px!important;
  .menu{
    height: 100%;
  }
  .right-btn{
    display: none;
  }
}
.wrapper{
  max-width: 1200px;
  width: 100%;
  margin: 0 auto;
  height: 100%;
  padding: 0 20px;
  display: flex;
  align-items: center;
  box-sizing: border-box;
  .logo{
    cursor: pointer;
    img{
      height: 40px;
      margin-right: 30px;
    }
  }
  .el-menu.el-menu--horizontal{
    border-bottom: 0;
    height: 100%;
    background: transparent;
    .el-menu-item{
      height: 100%;
      background: transparent!important;
      color: rgba(255,255,255,.6);
      font-size: 16px;
      display: flex;
      align-items: center;
      justify-content: center;
      padding: 0 30px;
      border-bottom: 0!important;
      &:hover{
        color: rgba(255,255,255,.8);
      }
      &.is-active{
        border-bottom: 0;
        color: #fff;
      }
    }
  }
}

/* 平板设备适配 */
@media screen and (max-width: 1024px) and (min-width: 769px) {
  .wrapper{
    padding: 0 15px;
    .logo img{
      margin-right: 20px;
    }
    .el-menu.el-menu--horizontal .el-menu-item{
      font-size: 14px;
      padding: 0 15px;
    }
  }
}

/* 小屏幕PC设备适配 */
@media screen and (max-width: 1480px){
  .wrapper .el-menu.el-menu--horizontal .el-menu-item{
    font-size: 15px;
    padding: 0 25px;
  }
  .banner-text .info{
    font-size: 18px;
    line-height: 28px;
  }
}
@media screen and (max-width: 790px){
  .show-menu{
    .el-header{
      height: 330px!important;
    }
  }
  .el-header{
    height: 56px!important;
    transition: all .3s ease-in-out;
  }
  .wrapper{
    width: 100%;
    padding: 0 ;
    .logo{
      position: absolute;
      top: 10px;
      img{
        height: 32px;
        width: auto;
      }
    }
    .menu{
      position: absolute;
      width: 100%;
      left: 0;
      top: 50px;
      height: 0;
      overflow: hidden;
      transition: height .3s ease-in-out;
      .el-menu--horizontal > .el-menu-item{
        height: 54px;
        font-size: 14px;
      }
      &.show{
        height: auto;
        padding-bottom: 20px;
      }
      .el-menu.el-menu--horizontal{
        flex-direction: column;
        display: flex;
        width: 100%;
        align-items: flex-start;
      }
    }
    .right-btn{
      display: flex;
      width: 44px;
      height: 28px;
      justify-content: space-around;
      flex-direction: column;
      align-items: center;
      position: absolute;
      right: 8px;
      top: 24px;
      transform: translateY(-50%);
      &.close{
        span{
          &:nth-child(1){
            transform: rotate(45deg);
            transform-origin: 0 0;
          }
          &:nth-child(2){
            opacity: 0;
          }
          &:nth-child(3){
            transform: rotate(-45deg);
            transform-origin: 0 0;
          }
        }
      }
      span{
        display: block;
        width: 28px;
        height: 2px;
        background: #fff;
        border-radius: 2px;

        transition: all ease-in-out .3s;
      }
    }
  }
  .banner-text {
    .link{
      margin-top: 8px!important;
    }
    .info{
      margin-top: 12px!important;
    }

  }
}

.el-carousel__mask{
  background: transparent;
}
/* 超小屏幕移动端 (小于375px) - iPhone SE等小屏手机 */
@media screen and (max-width: 374px) {
  /* 样式规则 */
}

/* 小屏幕移动端 (375px-479px) - iPhone等标准手机 */
@media screen and (max-width: 479px) and (min-width: 375px) {
  /* 样式规则 */
}

/* 中屏幕移动端 (480px-768px) - 大屏手机 */
@media screen and (max-width: 768px) and (min-width: 480px) {
  /* 样式规则 */
   .wrapper .right-btn{
    transform: scale(1) translateY(-50%);
  }
}

/* 所有移动端 (小于768px) */
@media screen and (max-width: 767px) {
  /* 样式规则 */
  .wrapper .right-btn{
    transform: scale(0.8) translateY(-50%);
  }
}
@media screen and (max-width: 790px) {
  /* 样式规则 */
  .wrapper .right-btn{
    transform: scale(0.8) translateY(-50%);
  }
}
/* 小屏平板 (769px-1024px) - iPad Mini等 */
@media screen and (max-width: 1024px) and (min-width: 769px) {
  /* 样式规则 */
  .wrapper .right-btn{
    transform: scale(0.8) translateY(-50%);
  }
}

/* 大屏平板 (1025px-1199px) - iPad Pro等 */
@media screen and (max-width: 1199px) and (min-width: 1025px) {
  /* 样式规则 */
}

/* 小屏幕PC (1200px-1399px) - 13-14寸笔记本 */
@media screen and (max-width: 1399px) and (min-width: 1200px) {
  /* 样式规则 */
}

/* 中屏幕PC (1400px-1599px) - 15-16寸笔记本/小屏显示器 */
@media screen and (max-width: 1599px) and (min-width: 1400px) {
  /* 样式规则 */
}

/* 大屏幕PC (1600px-1919px) - 22-24寸显示器 */
@media screen and (max-width: 1919px) and (min-width: 1600px) {
  /* 样式规则 */
}

/* 超大屏幕PC (1920px及以上) - 27寸以上显示器 */
@media screen and (min-width: 1920px) {
  /* 样式规则 */
}

/* 超高清屏幕 (2K及以上) */
@media screen and (min-width: 2560px) {
  /* 样式规则 */
  
}
</style>
